<template>
    <div class="requerimento" v-if="!loading">

            <!-- cabelalho -->
            <div>
                <table>
                    <tr>
                        <td valign="top" class="col-t-45 center top">
                            <h2>PREFEITURA DE ÁGUAS DE LINDÓIA</h2>
                            <h3>SECRETARIA MUNICIPAL DA EDUCAÇÃO</h3>
                        </td>
                        <td valign="top" class="col-t-45 center top">
                            <h1>HISTÓRICO ESCOLAR</h1>
                        </td>
                    </tr>
                </table>
            </div>

            <!-- dados da instituição -->
            <div class="borda mt-10">
                <table class="linha-tabela">
                    <tr>
                        <th class="col-t-80 coluna-tabela">
                            <p><b>Unidade Escolar: </b> {{ dados.instituicao.nome }}</p>
                        </th>
                        <th class="col-t-20 coluna-tabela ultima-coluna">
                            <p><b>Código: </b>{{ dados.instituicao.cod }}</p>
                        </th>
                    </tr>
                </table>
                <table class="linha-tabela">
                    <tr>
                        <th class="col-t-100 coluna-tabela ultima-coluna">
                            <p><b>Endereço: </b> {{ dados.instituicao.endereco }}</p>
                        </th>
                    </tr>
                </table>
                <table class="linha-tabela ultima-linha">
                    <tr>
                        <th class="col-t-50 coluna-tabela">
                            <p><b>Cod. Autorização: </b> {{ dados.instituicao.autorizacao }}</p>
                        </th>
                        <th class="col-t-50 coluna-tabela ultima-coluna">
                            <p><b>Cód. de Segurança de Res. CME no 030/00: </b> {{ dados.instituicao.cod_seguranca }}</p>
                        </th>
                    </tr>
                </table>
            </div>

            <!-- dados do aluno -->
            <div class="borda mt-10">
                <table class="linha-tabela">
                    <tr>
                        <th class="col-t-80 coluna-tabela">
                            <p><b>Nome do Aluno: </b> {{ dados.aluno.nome }}</p>
                        </th>
                        <th class="col-t-20 coluna-tabela ultima-coluna">
                            <p><b>Sexo: </b>{{ dados.aluno.sexo }}</p>
                        </th>
                    </tr>
                </table>
                <table class="linha-tabela">
                    <tr>
                        <th class="col-t-25 coluna-tabela">
                            <p><b>Data de Nascimento: </b> {{ dados.aluno.data_nascimento }}</p>
                        </th>
                        <th class="col-t-25 coluna-tabela">
                            <p><b>Naturalidade: </b> {{ dados.aluno.naturalidade }}</p>
                        </th>
                        <th class="col-t-25 coluna-tabela ultima-coluna">
                            <p><b>Nacionalidade: </b> {{ dados.aluno.nacionalidade }}</p>
                        </th>
                    </tr>
                </table>
                <table class="linha-tabela ultima-linha">
                    <tr>
                        <th class="col-t-50 coluna-tabela">
                            <p><b>Nome do Pai: </b> {{ dados.aluno.pai }}</p>
                        </th>
                        <th class="col-t-50 coluna-tabela ultima-coluna">
                            <p><b>Nome da Mãe: </b> {{ dados.aluno.mae }}</p>
                        </th>
                    </tr>
                </table>
            </div>

            <!-- notas -->
            <div class="borda mt-10">
                <table class="tabela-nota linha-tabela ultima-linha">
                    <tr>
                        <th colspan="10" class="col-t-30 coluna-tabela center ultima-coluna">
                            <p>NOTAS</p>
                        </th>
                    </tr>
                    <tr>
                        <th class="col-t-15 coluna-tabela border-top">
                            <p>Áreas de Conhecimentos</p>
                        </th>
                        <th @click="showDialogEditNotas(idNota)" v-for="(nota, idNota) in dados.grade.conteudo.notas" :key="idNota" class="col-t-5 coluna-tabela center border-top u-pointer">
                            <p>
                                {{ $CONSTANTS.CURSO_NACIONAL[idNota] }}
                                <i class="fas fa-edit" style="color: #838383"></i> <br>
                                {{ nota.aprovado_por_resolucao ? 'Resolução' : 'Média' }}
                            </p>
                        </th>
                    </tr>
                    <tr v-for="(disciplina, idDisciplina, index) in dados.disciplinas" :key="idDisciplina">
                        <th class="col-t-15 coluna-tabela border-top">
                            <p>{{ disciplina }}</p>
                        </th>
                        <template v-for="(nota, idNota) in dados.grade.conteudo.notas">
                            <th v-if="nota.aprovado_por_resolucao && index === 0" :key="idNota" :rowspan="Object.keys(dados.disciplinas).length" class="col-t-5 coluna-tabela center border-top" style="vertical-align: middle;">
                                <span class="resolucao-vertical-modal">{{ nota.resolucao }}</span>
                            </th>
                            <th v-else-if="!nota.aprovado_por_resolucao && nota.tipo == 'qualitativo'" :key="idNota" class="col-t-5 coluna-tabela center border-top">
                                <p>resolução</p>
                            </th>
                            <th v-else-if="!nota.aprovado_por_resolucao" :key="idNota" class="col-t-5 coluna-tabela center border-top">
                                <p>{{ (nota.disciplinas[idDisciplina] === null || nota.disciplinas[idDisciplina] === undefined || nota.disciplinas[idDisciplina] === '') ? '-' : nota.disciplinas[idDisciplina] }}</p>
                            </th>
                        </template>
                    </tr>
                    <!-- Sem nenhuma disciplina: linha em branco para a resolução aparecer -->
                    <tr v-if="Object.keys(dados.disciplinas).length === 0">
                        <th class="col-t-15 coluna-tabela center border-top">
                            <p>-</p>
                        </th>
                        <template v-for="(nota, idNota) in dados.grade.conteudo.notas">
                            <th v-if="nota.aprovado_por_resolucao" :key="idNota" class="col-t-5 coluna-tabela center border-top" style="vertical-align: middle;">
                                <span class="resolucao-vertical-modal">{{ nota.resolucao }}</span>
                            </th>
                            <th v-else :key="idNota" class="col-t-5 coluna-tabela center border-top">
                                <p>-</p>
                            </th>
                        </template>
                    </tr>
                    <tr>
                        <th class="col-t-15 coluna-tabela border-top">
                            <p>Faltas</p>
                        </th>
                        <template v-for="(nota, idNota) in dados.grade.conteudo.notas">
                            <th :key="idNota" class="col-t-5 coluna-tabela center border-top">
                                <p>{{ nota.aprovado_por_resolucao ? '-' : ((nota.total_faltas === null || nota.total_faltas === '') ? '-' : nota.total_faltas) }}</p>
                            </th>
                        </template>
                    </tr>
                    <tr>
                        <th class="col-t-15 coluna-tabela border-top">
                            <p>Carga horária anual</p>
                        </th>
                        <template v-for="(nota, idNota) in dados.grade.conteudo.notas">
                            <th :key="idNota" class="col-t-5 coluna-tabela center border-top">
                                <p>{{ nota.aprovado_por_resolucao ? '-' : ((nota.carga_horaria_anual === null || nota.carga_horaria_anual === '') ? '-' : nota.carga_horaria_anual) }}</p>
                            </th>
                        </template>
                    </tr>
                </table>
            </div>

            <!-- estudos realizados -->
            <div class="borda mt-10">
                <table class="tabela-nota linha-tabela ultima-linha">
                    <tr>
                        <th colspan="5" class="col-t-30 coluna-tabela center ultima-coluna">
                            <p>ESTUDOS REALIZADOS</p>
                        </th>
                    </tr>
                    <tr>
                        <th class="col-t-30 coluna-tabela border-top">
                            <p>Modalidade de Ensino</p>
                        </th>
                        <th class="col-t-10 coluna-tabela center border-top">
                            <p>Ano</p>
                        </th>
                        <th class="col-t-30 coluna-tabela center border-top">
                            <p>Unidade de Ensino</p>
                        </th>
                        <th class="col-t-20 coluna-tabela center border-top">
                            <p>Cidade</p>
                        </th>
                        <th class="col-t-10 coluna-tabela center border-top ultima-coluna">
                            <p>UF</p>
                        </th>
                    </tr>
                    <tr v-for="(nota, idNota) in dados.grade.conteudo.notas">
                        <th @click="showDialogEstudosRealizados(idNota)" class="col-t-30 coluna-tabela border-top u-pointer">
                            <p>
                                {{ idNota ? $CONSTANTS.CURSO_NACIONAL[idNota] : '-' }}
                                <i class="fas fa-edit" style="color: #838383"></i>
                            </p>
                        </th>
                        <th class="col-t-10 coluna-tabela center border-top">
                            <p>{{ nota.ano ? nota.ano : '-' }}</p>
                        </th>
                        <th class="col-t-30 coluna-tabela center border-top">
                            <p>{{ nota.unidade_ensino ? nota.unidade_ensino : '-' }}</p>
                        </th>
                        <th class="col-t-20 coluna-tabela center border-top">
                            <p>{{ nota.cidade ? nota.cidade : '-' }}</p>
                        </th>
                        <th class="col-t-10 coluna-tabela center border-top ultima-coluna">
                            <p>{{ nota.UF ? nota.UF : '-' }}</p>
                        </th>
                    </tr>
                    
                </table>
            </div>

            <!-- equivalência -->
            <div class="borda mt-10">
                <table class="tabela-nota linha-tabela ultima-linha">
                    <tr>
                        <th colspan="2" class="col-t-30 coluna-tabela center ultima-coluna">
                            <p>EQUIVALÊNCIA COM O ENSINO FUNDAMENTAL REGULAR</p>
                        </th>
                    </tr>
                    <tr v-for="(equivalencia, idNota) in dados.grade.conteudo.equivalencia">
                        <th class="col-t-100 coluna-tabela border-top">
                            <p>{{ equivalencia }}</p>
                        </th>
                    </tr>
                    <template v-if="dados.grade.conteudo.equivalencia.length == 0">
                        <tr>
                            <th class="col-t-100 coluna-tabela border-top center ultima-coluna">-</th>
                        </tr>
                        <tr>
                            <th class="col-t-100 coluna-tabela border-top center ultima-coluna">-</th>
                        </tr>
                        <tr>
                            <th class="col-t-100 coluna-tabela border-top center ultima-coluna">-</th>
                        </tr>
                        <tr>
                            <th class="col-t-100 coluna-tabela border-top center ultima-coluna">-</th>
                        </tr>
                        <tr>
                            <th class="col-t-100 coluna-tabela border-top center ultima-coluna">-</th>
                        </tr>
                    </template>
                </table>
            </div>

            <!-- observações -->
            <div class="borda mt-10">
                <table class="tabela-nota linha-tabela ultima-linha">
                    <tr>
                        <th @click="showDialogObservacoes()" colspan="" class="col-t-30 coluna-tabela center ultima-coluna u-pointer">
                            <p>OBSERVAÇÕES <i class="fas fa-edit" style="color: #838383"></i></p>                            
                        </th>
                    </tr>
                    <tr v-if="dados.grade.conteudo.observacoes">
                        <th class="col-t-100 coluna-tabela border-top ultima-coluna">
                            <p>{{ dados.grade.conteudo.observacoes }}</p>
                        </th>
                    </tr>
                    <template v-if="!dados.grade.conteudo.observacoes">
                        <tr>
                            <th class="col-t-100 coluna-tabela center border-top ultima-coluna">-</th>
                        </tr>
                        <tr>
                            <th class="col-t-100 coluna-tabela center border-top ultima-coluna">-</th>
                        </tr>
                        <tr>
                            <th class="col-t-100 coluna-tabela center border-top ultima-coluna">-</th>
                        </tr>
                        <tr>
                            <th class="col-t-100 coluna-tabela center border-top ultima-coluna">-</th>
                        </tr>
                    </template>
                </table>
            </div>

            <!-- parecer final -->
            <div class="borda mt-10">
                <table class="tabela-nota linha-tabela ultima-linha">
                    <tr>
                        <th @click="showDialogParecerFinal()" colspan="" class="col-t-30 coluna-tabela center ultima-coluna u-pointer">
                            <p>PARECER FINAL <i class="fas fa-edit" style="color: #838383"></i></p>
                        </th>
                    </tr>
                    <tr>
                        <th class="col-t-100 coluna-tabela border-top ultima-coluna">
                            <p>{{ dados.grade.conteudo.parecer_final ? dados.grade.conteudo.parecer_final : '-' }}</p>
                        </th>
                    </tr>
                </table>
            </div>

            <el-row :gutter="10" class="u-mt-10">
                <el-col :xs="24" :sm="24" :md="24">
                    <div style="display: flex; justify-content: space-between;">
                        <el-button type="danger" plain @click="excluirHistorico()">
                            <i class="fas fa-trash-alt"></i> EXCLUIR HISTÓRICO
                        </el-button>
                        <el-button @click="onSubmitHistoricoEscolar()">IMPRIMIR</el-button>
                    </div>
                </el-col>
            </el-row>

            <el-dialog :close-on-click-modal="false" title="IMPRESSÃO HISTÓRICO ESCOLAR" width="50%" :visible.sync="dialogEditNota" v-on:close="closeDialogEditNota" append-to-body>
                <div v-if="dialogEditNota" style="margin-top: 20px;">

                    <el-form label-position="top">
                        <el-form-item label="Possui resolução?">
                            <el-select v-model="dados.grade.conteudo.notas[idNotaSelected].aprovado_por_resolucao" @change="onChangeSerieResolucao" style="width: 100%;">
                                <el-option :value="true" label="SIM"></el-option>
                                <el-option :value="false" label="NÃO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>

                    <!-- Faltas / Carga horária (editáveis; o sistema traz o padrão, o usuário pode alterar) -->
                    <el-form v-if="!dados.grade.conteudo.notas[idNotaSelected].aprovado_por_resolucao" label-position="top">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Faltas">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].total_faltas" @input="marcarFaltasManual" placeholder="-"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Carga horária anual">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].carga_horaria_anual" @input="marcarCargaManual" placeholder="-"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>

                    <!-- Série aprovada por resolução: texto livre no lugar das disciplinas -->
                    <template v-if="dados.grade.conteudo.notas[idNotaSelected].aprovado_por_resolucao">
                        <el-form label-position="top" class="u-mt-10">
                            <el-form-item label="Resolução">
                                <el-input type="textarea" autosize v-model="dados.grade.conteudo.notas[idNotaSelected].resolucao" @input="marcarResolucaoManual" placeholder="Informe a resolução"></el-input>
                            </el-form-item>
                        </el-form>
                        <el-row :gutter="10" class="u-mt-10">
                            <el-col :xs="24">
                                <div class="u-text-right">
                                    <el-button @click="onSubmitFormEditNota" native-type="submit">SALVAR</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </template>

                    <!-- Lançamento normal de notas/conceitos -->
                    <template v-else>
                        <!-- Disciplinas já lançadas na série (edita a média) -->
                        <div v-if="temDisciplinasExistentes" class="borda mt-10" style="border-top: none;">
                            <table class="tabela-nota linha-tabela ultima-linha">

                                <tr v-for="(nota, disciplina) in dados.grade.conteudo.notas[idNotaSelected].disciplinas" :key="disciplina">
                                    <th class="col-t-50 coluna-tabela border-top">
                                        <p>{{ dados.disciplinas[disciplina] || disciplina }}</p>
                                    </th>
                                    <th class="col-t-50 coluna-tabela border-top ultima-coluna">
                                        <p>
                                            <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].disciplinas[disciplina]" maxlength="191"></el-input>
                                        </p>
                                    </th>
                                </tr>

                            </table>
                        </div>

                        <!-- Novas disciplinas a adicionar -->
                        <el-form label-position="top" v-if="formNotaExterna.length">
                            <el-row :gutter="10" v-for="(item, i) in formNotaExterna" class="u-mt-5" :key="'nova-' + i">
                                <el-col :xs="24" :sm="12" :md="12">
                                    <el-form-item label="Disciplina" :key="'disc-' + i">
                                        <el-input v-model="formNotaExterna[i].disciplina" maxlength="191" v-on:blur="formatData(i, 'disciplina')"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="11" :md="11">
                                    <el-form-item label="Nota" :key="'nota-' + i">
                                        <el-input v-model="formNotaExterna[i].nota" maxlength="191"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="1" :md="1" class="u-text-right">
                                    <el-button @click="removeDisciplina(i)" type="danger" plain style="margin-top: 21px;">
                                        <i class="fas fa-trash-alt"></i>
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-form>
                        <el-row :gutter="10" class="u-mt-10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-button @click="addDisciplina()" type="primary" plain>
                                    <i class="fas fa-plus"></i> ADICIONAR DISCIPLINA
                                </el-button>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12">
                                <div class="u-text-right">
                                    <el-button @click="onSubmitFormEditNota" native-type="submit">SALVAR</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </template>
                </div>
            </el-dialog>

            <el-dialog :close-on-click-modal="false" title="GERENCIAR ESTUDOS REALIZADOS" width="70%" :visible.sync="dialogEstudosRealizados" v-on:close="closeDialogEstudosRealizados" append-to-body>
                <div v-if="dialogEstudosRealizados" style="margin-top: 20px;">
                    
                    <el-form label-position="top">
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Ano" prop="ano" key="ano">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].ano" maxlength="191"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>    
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Unidade de Ensino" prop="unidade_ensino" key="unidade_ensino">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].unidade_ensino" maxlength="191" v-on:blur="formatDataUnidade('unidade_ensino')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>  
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Cidade" prop="cidade" key="cidade">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].cidade" maxlength="191" v-on:blur="formatDataUnidade('cidade')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Estado" prop="UF" key="UF">
                                    <el-input v-model="dados.grade.conteudo.notas[idNotaSelected].UF" maxlength="191" v-on:blur="formatDataUnidade('UF')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row> 
                    </el-form>
                        
                    <el-row :gutter="10" class="u-mt-10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <div class="u-text-right">
                                <el-button @click="onSubmitEstudosRealizados()" native-type="submit">SALVAR</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>

            <el-dialog :close-on-click-modal="false" title="GERENCIAR OBSERVAÇÕES" width="70%" :visible.sync="dialogObservacoes" v-on:close="closeDialogObservacoes" append-to-body>
                <div v-if="dialogObservacoes" style="margin-top: 20px;">
                    
                    <el-form label-position="top">
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Observações" prop="observacoes" key="observacoes">
                                    <el-input type="textarea" autosize v-model="dados.grade.conteudo.observacoes"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>  
                    </el-form>                        
                    <el-row :gutter="10" class="u-mt-10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <div class="u-text-right">
                                <el-button @click="onSubmitObservacoes()" native-type="submit">SALVAR</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>

            <el-dialog :close-on-click-modal="false" title="GERENCIAR PARECER FINAL" width="70%" :visible.sync="dialogParecerFinal" v-on:close="closeDialogParecerFinal" append-to-body>
                <div v-if="dialogParecerFinal" style="margin-top: 20px;">

                    <el-form label-position="top">
                        <el-row :gutter="10" class="u-mt-5">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Parecer final" prop="parecer_final" key="parecer_final">
                                    <el-input type="textarea" autosize v-model="dados.grade.conteudo.parecer_final"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-row :gutter="10" class="u-mt-10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <div class="u-text-right">
                                <el-button @click="onSubmitParecerFinal()" native-type="submit">SALVAR</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>

        </div>
</template>
<script>
import Vue from 'vue'

export default {
    props: ['aluno'],
    data: () => ({
        idNotaSelected: '',
        dialogEditNota: false,
        dialogEstudosRealizados: false,
        dialogObservacoes: false,
        dialogParecerFinal: false,
        loading: true,
        dados:{ },
        formNotaExterna: []
    }),
    computed: {
        temDisciplinasExistentes () {
            if (!this.dados || !this.dados.grade || !this.dados.grade.conteudo) return false;
            const serie = this.dados.grade.conteudo.notas[this.idNotaSelected];
            return !!(serie && serie.disciplinas && Object.keys(serie.disciplinas).length > 0);
        }
    },
    mounted () {

        this.getDados()
    },
    methods:{
        getDados(){

            this.loading = true;

            let i = this.$store.state.config.instituicao.id;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/diario/get-dados-historico-escolar/${i}/${this.aluno.id}`, this.$store.getters.getHeaderAuth).then(response => {

                if(typeof response.data.erro !== 'undefined'){

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                    this.$emit('closeModal');

                }else{

                    this.dados = response.data;
                    this.loading = false;
                }
                
            }).catch((error) => { this.$store.commit('throwException', error); });
            
        },
        showDialogEditNotas(idNota) {
            this.idNotaSelected = idNota;

            const serie = this.dados.grade.conteudo.notas[idNota];

            // Garante reatividade dos campos (snapshots antigos podem não ter).
            if (!('aprovado_por_resolucao' in serie)) Vue.set(serie, 'aprovado_por_resolucao', false);
            if (!('resolucao' in serie)) Vue.set(serie, 'resolucao', null);
            if (!('total_faltas' in serie)) Vue.set(serie, 'total_faltas', null);
            if (!('carga_horaria_anual' in serie)) Vue.set(serie, 'carga_horaria_anual', null);

            // Garante que sejam objetos (não arrays).
            if (!serie.disciplinas || Array.isArray(serie.disciplinas)) Vue.set(serie, 'disciplinas', {});
            if (!serie.disciplinas_traducao || Array.isArray(serie.disciplinas_traducao)) Vue.set(serie, 'disciplinas_traducao', {});

            // Toda disciplina já existente no histórico (união de todas as séries) deve aparecer
            // nesta série para lançamento, mesmo que fique em branco — o usuário decide preencher.
            for (const key in this.dados.disciplinas) {
                if (!Object.prototype.hasOwnProperty.call(serie.disciplinas, key)) {
                    Vue.set(serie.disciplinas, key, '');
                }
                if (!Object.prototype.hasOwnProperty.call(serie.disciplinas_traducao, key)) {
                    Vue.set(serie.disciplinas_traducao, key, this.dados.disciplinas[key]);
                }
            }

            this.dialogEditNota = true;
        },
        closeDialogEditNota() {
            this.dialogEditNota = false;
            this.idNotaSelected = {};
            this.formNotaExterna = []
        },
        onChangeSerieResolucao(value) {
            const serie = this.dados.grade.conteudo.notas[this.idNotaSelected];
            // Marca como definição MANUAL (o backend não recomputa quando manual).
            Vue.set(serie, 'resolucao_manual', value);
            Vue.set(serie, 'aprovado_por_resolucao', value);
            if (!value) {
                // Desmarcou: limpa a resolução (volta a mostrar as disciplinas).
                Vue.set(serie, 'resolucao', null);
            } else if (serie.resolucao === undefined || serie.resolucao === null) {
                Vue.set(serie, 'resolucao', '');
            }
        },
        marcarResolucaoManual() {
            // Usuário editou o texto da resolução (mesmo que puxada do sistema) → vira override
            // manual, para o backend não recomputar e sobrescrever com a resolução do curso.
            const serie = this.dados.grade.conteudo.notas[this.idNotaSelected];
            Vue.set(serie, 'resolucao_manual', serie.aprovado_por_resolucao);
        },
        marcarFaltasManual() {
            // Usuário alterou as faltas → vira override manual (backend não recomputa).
            Vue.set(this.dados.grade.conteudo.notas[this.idNotaSelected], 'total_faltas_manual', true);
        },
        marcarCargaManual() {
            // Usuário alterou a carga → vira override manual (backend não recomputa).
            Vue.set(this.dados.grade.conteudo.notas[this.idNotaSelected], 'carga_horaria_anual_manual', true);
        },
        onSubmitFormEditNota() {

            const serie = this.dados.grade.conteudo.notas[this.idNotaSelected];

            // Garante que disciplinas / disciplinas_traducao sejam objetos (não arrays).
            if (!serie.disciplinas || Array.isArray(serie.disciplinas)) Vue.set(serie, 'disciplinas', {});
            if (!serie.disciplinas_traducao || Array.isArray(serie.disciplinas_traducao)) Vue.set(serie, 'disciplinas_traducao', {});

            // Anexa as novas disciplinas digitadas (ignora linhas em branco). As notas já
            // existentes são editadas direto pelos inputs (v-model), então não são tocadas.
            for (let i in this.formNotaExterna) {
                const nova = this.formNotaExterna[i];
                if (!nova.disciplina) continue;

                const chave = 'ext_' + this.idNotaSelected + '_' + Date.now() + '_' + i;

                Vue.set(this.dados.disciplinas, chave, nova.disciplina);
                Vue.set(serie.disciplinas, chave, nova.nota);
                Vue.set(serie.disciplinas_traducao, chave, nova.disciplina);
            }

            this.formNotaExterna = [];
            this.dialogEditNota = false;
        },
        addDisciplina() {
            this.formNotaExterna.push({
                disciplina: '',
                nota: ''
            });
        },
        removeDisciplina(i) {
            this.formNotaExterna.splice(i, 1);
        },        
        showDialogEstudosRealizados(idNota) {
            this.dialogEstudosRealizados = true;
            this.idNotaSelected = idNota;
        },
        closeDialogEstudosRealizados() {
            this.dialogEstudosRealizados = false;
            this.idNotaSelected = {};
        },
        onSubmitEstudosRealizados(){

            this.dialogEstudosRealizados = false;
        },   
        showDialogObservacoes() {
            this.dialogObservacoes = true;
        },
        closeDialogObservacoes() {
            this.dialogObservacoes = false;
        },
        onSubmitObservacoes(){

            this.dialogObservacoes = false;
        },
        showDialogParecerFinal() {
            // Garante reatividade caso o snapshot antigo não tenha o campo.
            if (typeof this.dados.grade.conteudo.parecer_final === 'undefined') {
                Vue.set(this.dados.grade.conteudo, 'parecer_final', null);
            }
            this.dialogParecerFinal = true;
        },
        closeDialogParecerFinal() {
            this.dialogParecerFinal = false;
        },
        onSubmitParecerFinal(){

            this.dialogParecerFinal = false;
        },
        formatData(i, field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA 
                        
            if(!this.formNotaExterna[i][field])
                return false;

            if(size && this.formNotaExterna[i][field].length < size)
                this.formNotaExterna[i][field] = '';            

            this.formNotaExterna[i][field] = this.formNotaExterna[i][field].toUpperCase();

            this.formNotaExterna[i][field] = this.$removerAcentos(this.formNotaExterna[i][field]);
        },
        formatDataUnidade(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA 
                        
            if(!this.dados.grade.conteudo.notas[this.idNotaSelected][field])
                return false;

            if(size && this.dados.grade.conteudo.notas[this.idNotaSelected][field].length < size)
                this.dados.grade.conteudo.notas[this.idNotaSelected][field] = '';            

            this.dados.grade.conteudo.notas[this.idNotaSelected][field] = this.dados.grade.conteudo.notas[this.idNotaSelected][field].toUpperCase();

            this.dados.grade.conteudo.notas[this.idNotaSelected][field] = this.$removerAcentos(this.dados.grade.conteudo.notas[this.idNotaSelected][field]);
        },
        onSubmitHistoricoEscolar() {

            const parecerFinal = this.dados.grade.conteudo.parecer_final;
            if (!parecerFinal || String(parecerFinal).trim() === '') {
                window.eventBus.$emit('alert', {msg: 'Informe o Parecer Final antes de imprimir o histórico.', type: 'warning'});
                return;
            }

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/storeHistoricoEscolar/${this.aluno.id}`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
            
                if(typeof response.data.erro !== 'undefined'){

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});

                }else{

                    let i = this.$store.state.config.instituicao.id;

                    window.eventBus.$emit('print', {url: '/api/diario/printHistoricoEscolar', param: {aluno_id: this.aluno.id, instituicao_id: i }});

                    this.$emit('closeModal');
                }

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

        },
        excluirHistorico() {

            this.$confirm('Isso vai apagar o histórico salvo, incluindo notas, estudos realizados e observações inseridos manualmente. Ao reabrir, o histórico será recriado apenas com os dados atuais do sistema. Deseja continuar?', 'Excluir histórico', {
                confirmButtonText: 'Excluir',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/diario/deleteHistoricoEscolar/${this.aluno.id}`, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);

                    if(typeof response.data.erro !== 'undefined'){
                        window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                        return;
                    }

                    window.eventBus.$emit('alert', {msg: 'Histórico excluído. Recriado com os dados do sistema.', type: 'success'});
                    this.getDados();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(() => {});

        },
    },
    components:{ }
}
</script>
<style scoped>

    p {
        font-size: 11px;
        font-weight: normal;
    }

    .resolucao-vertical-modal {
        writing-mode: vertical-rl;
        transform: rotate(180deg);
        white-space: nowrap;
        display: inline-block;
        font-size: 12px;
        padding: 6px 0;
    }

    b {
        font-weight: bold;
    }

    h3 {
        font-size: 13px;
        font-weight: bold;
    }

    h4 {
        font-size: 13px;
        font-weight: normal;
    }

    table, td, th {
        table-layout: auto;
        width: 100%;
    }

    .linha {
        padding-left: 10px;
        padding-right: 10px;
    }

    .primeira-linha {
        padding-top: 5px;
    }

    .linha-tabela {
        border-collapse: collapse;
        border-bottom: 1px solid black;
    }

    .ultima-linha {
        border-bottom: none;
    }

    .coluna-tabela {
        table-layout: auto;
        border-right: 1px solid black;
        text-align: left;
    }

    .ultima-coluna {
        border-right: none;
    }

    .quadro-interno {
        height: 115px;
    }

    .quadro-lateral {
        margin-left: 8px;
        margin-right: 8px;
        height: 115px;
    }

    .col-t-5 {
        width: 5%;
    }

    .col-t-10 {
        width: 10%;
    }

    .col-t-15 {
        width: 15%;
    }

    .col-t-20 {
        width: 20%;
    }

    .col-t-25 {
        width: 25%;
    }

    .col-t-30 {
        width: 30%;
    }

    .col-t-33 {
        width: 33%;
    }

    .col-t-35 {
        width: 35%;
    }

    .col-t-40 {
        width: 40%;
    }

    .col-t-42 {
        width: 42%;
    }

    .col-t-45 {
        width: 42%;
    }

    .col-t-50 {
        width: 50%;
    }

    .col-t-55 {
        width: 50%;
    }

    .col-t-60 {
        width: 60%;
    }

    .col-t-65 {
        width: 60%;
    }

    .col-t-70 {
        width: 70%;
    }

    .col-t-75 {
        width: 70%;
    }

    .col-t-80 {
        width: 80%;
    }

    .col-t-85 {
        width: 80%;
    }

    .col-t-90 {
        width: 90%;
    }

    .col-t-95 {
        width: 90%;
    }

    .col-t-100 {
        width: 100%;
    }

    .borda {
        overflow-x: hidden;
        border: 1px solid #000000;
        border-radius: 8px;
        /* margin-bottom: 3px; */
        font-weight: 700;
    }

    .center {
        text-align: center;
    }

    .top {
        padding-top: 20px;
    }

    .right {
        text-align: right;
    }

    .justify {
        text-align: justify;
    }

    h2 {
        font-size: 16px;
    }

    h1 {
        font-size: 18px;
        font-weight: normal;
    }

    html{
        /* margin:20px 50px; */
        margin: 25px 25px 25px 25px; /* top right bottom left */
    }

    h1,h2,h3,h4,th,td,p,div,b {
        margin: 0;
        padding: 0;
    }

    .linha-tabela p {
        margin: 2px 2px 3px 4px;
    }

    .borda {
        margin-bottom: 5px;
    }

    .margin-bottom-5 {
        margin-bottom: 8px;
    }

    .margin-bottom-10 {
        margin-bottom: 10px;
    }

    .small-font {
        font-size: 10px;
    }

    .tiny-font {
        font-size: 5px;
    }

    .linha-tracejada {
        border: none;
        border-top: 1px dotted black;
        color: #fff;
        background-color: #fff;
        height: 1px;
    }

    .mt-40{
        margin-top: 40px !important;
    }

    .mt-30{
        margin-top: 30px !important;
    }

    .mt-20{
        margin-top: 20px !important;
    }

    .mt-10{
        margin-top: 5px;
    }

    .mt-5{
        margin-top: 5px;
    }

    .pl-10{
        padding-left: 10px;
    }

    .border05{
        border-bottom: 0.5px solid #000;
    }

    .my-5{
        margin: 5px 0px;
    }

    .text-left{
        text-align: left !important;
    }

    .requerimento {
        font-family: "Arial", "Helvetica", "sans-serif";
        page-break-inside: avoid;
    }

    .page-break {
        page-break-after: always;
    }

    .page-break:last-child {
        page-break-after: auto;
    }

    .border-top {
        border-top: 1px solid #000;
    }

    .vertical{
        writing-mode: vertical-rl;
        transform: rotate(180deg);
    }
</style>